module.exports = "/virtual-football-league/img/jerseys/Black.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/jerseys/Black.png
// module id = 182
// module chunks = 4